import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(function($) {
  
 var $window = $(window),
	  body = $('body'),
	  deviceAgent = navigator.userAgent.toLowerCase(),
	  isMobile = deviceAgent.match(/(iphone|ipod|android|iemobile)/),
	  isMobileAlt = deviceAgent.match(/(iphone|ipod|ipad|android|iemobile)/),
	  isAppleDevice = deviceAgent.match(/(iphone|ipod|ipad)/),
	  sIEMobile = deviceAgent.match(/(iemobile)/),
	  isSafari = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 &&  navigator.userAgent.indexOf('Android') == -1,
    windowW = $window.width(),
	  header = $('.header'),
    headerH = 80;
	
	// Get browser and add to body
    $.each($.browser, function (i) {
        $('body').addClass(i);
        return false;
    });
    // Get OS and add to body
    var os = [
        'iphone',
        'ipad',
        'windows',
        'mac',
        'linux'
    ];
    var match = navigator.appVersion.toLowerCase().match(new RegExp(os.join('|')));
    if (match) {
        $('body').addClass(match[0]);
    };
 
 
	
	/* detect touch */
	if("ontouchstart" in window){
		document.documentElement.className = document.documentElement.className + " touch";
	}
	
  
  $("body").addClass("loaded");
  
  
  /****** LOCOMOTIVE *******/
  
 const scroll = new LocomotiveScroll({
      lenisOptions: {
          wrapper: window,
          content: document.documentElement,
          lerp: 0.1,
          duration: 1,
          orientation: 'vertical',
          gestureOrientation: 'vertical',
          smoothWheel: true,
          smoothTouch: false,
          wheelMultiplier: 0.8,
          touchMultiplier: 2,
          normalizeWheel: true,
          autoResize: true,
          easing:  (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
      },
  });
  

  
  /**** IMAGE ROTATION  & PARALLAX *****/
  
  const img01 = gsap.timeline({ paused: true });
  const img02 = gsap.timeline({ paused: true });
  const img03 = gsap.timeline({ paused: true });
  const img04 = gsap.timeline({ paused: true });
  
  img01.to('.img01', { rotation:-8, yPercent:-20, duration: 1, ease: "0.4, 0, 0, 1" });
  img02.to('.img02', { rotation:8,  yPercent:-60, duration: 1, ease: "0.4, 0, 0, 1" });
  img03.to('.img03', { rotation:-8,  yPercent:-10,  duration: 1, ease: "0.4, 0, 0, 1" });
  img04.to('.img04', { rotation:8,  yPercent:-30,  duration: 1, ease: "0.4, 0, 0, 1" });
  
   window.addEventListener("img01", (e) => {
    const { progress } = e.detail;
     img01.progress(progress);
  });

   window.addEventListener("img02", (e) => {
    const { progress } = e.detail;
    img02.progress(progress);
  });

   window.addEventListener("img03", (e) => {
    const { progress } = e.detail;
     img03.progress(progress);
  });

   window.addEventListener("img04", (e) => {
    const { progress } = e.detail;
    img04.progress(progress);
  });
  

 /***** TEXT FILL ******/
  
const tl = gsap.timeline({ paused: true });

tl.to('.text-line', {  backgroundPosition:"0", duration: 0.3, ease: "0.4, 0, 0, 1" })
  .to('.text-line2', {  backgroundPosition:"0", duration: 0.3, ease: "0.4, 0, 0, 1" })
  .to('.text-line3', {  backgroundPosition:"0", duration: 0.3, ease: "0.4, 0, 0, 1" })
  .to('.text-line4', {  backgroundPosition:"0", duration: 0.3, ease: "0.4, 0, 0, 1" })
  .to('.text-line5', {  backgroundPosition:"0", duration: 0.3, ease: "0.4, 0, 0, 1" });


  window.addEventListener("text-fill", (e) => {
    const { progress } = e.detail;
    tl.progress(progress);
  });
  
  
  // FONCTION POUR ACTIVER LE VIDEO

/*    $('#videoModal').on('show.bs.modal', function (event) {
       $('#videoPlayer')[0].play();
        document.body.classList.add("video-open");
    });

    $('#videoModal').on('hide.bs.modal', function () {
        $('#videoPlayer')[0].pause(); 
        document.body.classList.remove("video-open");
    });
    
    
    document.getElementById('videoPlayer').addEventListener('ended',myHandler,false);
    function myHandler(e) {
        $('#videoPlayer')[0].pause(); 
        document.body.classList.remove("video-open");
        $('#videoModal').modal('hide');
    }
*/
  
 if ( $(".tasty-craft" ).length ) {
  
    $(window).scroll(function() {
      if(windowW >= 992) {
        var triggerTop = $('.blonde-ale_actif').offset().top;
        var triggerBottom = triggerTop + $('.blonde-ale_actif').outerHeight();
      } else {
        var triggerTop = $('.products.ipa').offset().top;
        var triggerBottom = triggerTop + $('.products.ipa').outerHeight();
      }
        var windowHeight = $(window).height();
        var windowTop = $(window).scrollTop();
        var windowBottom = windowTop + windowHeight;

        // Check if the trigger element is visible on the screen
        if (triggerTop < windowBottom && triggerBottom > windowTop) {
          $('.tasty-craft__text').addClass('hide');
        } else {
          $('.tasty-craft__text').removeClass('hide');
        }
      });
     
  }
  
}); 


// contain and invoke browser API
(function() {

    var matched, browser;

// More details: https://api.jquery.com/jQuery.browser
// jQuery.uaMatch maintained for back-compat
    jQuery.uaMatch = function( ua ) {
        ua = ua.toLowerCase();

        var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
            /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
            /(msie) ([\w.]+)/.exec( ua ) ||
            ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
            [];

        return {
            browser: match[ 1 ] || "",
            version: match[ 2 ] || "0"
        };
    };

    matched = jQuery.uaMatch( navigator.userAgent );
    browser = {};

    if ( matched.browser ) {
        browser[ matched.browser ] = true;
        browser.version = matched.version;
    }

// Chrome is Webkit, but Webkit is also Safari.
    if ( browser.chrome ) {
        browser.webkit = true;
    } else if ( browser.webkit ) {
        browser.safari = true;
    }

    jQuery.browser = browser;

    jQuery.sub = function() {
        function jQuerySub( selector, context ) {
            return new jQuerySub.fn.init( selector, context );
        }
        jQuery.extend( true, jQuerySub, this );
        jQuerySub.superclass = this;
        jQuerySub.fn = jQuerySub.prototype = this();
        jQuerySub.fn.constructor = jQuerySub;
        jQuerySub.sub = this.sub;
        jQuerySub.fn.init = function init( selector, context ) {
            if ( context && context instanceof jQuery && !(context instanceof jQuerySub) ) {
                context = jQuerySub( context );
            }

            return jQuery.fn.init.call( this, selector, context, rootjQuerySub );
        };
        jQuerySub.fn.init.prototype = jQuerySub.fn;
        var rootjQuerySub = jQuerySub(document);
        return jQuerySub;
    };

})();